/**
 * Row styling shared by Select, ComboBox and Menu. Focused rows use the `active` fill (one step
 * stronger than `hover`) so the highlight reads on the raised popover surface in both themes.
 */
export const optionRow =
  "flex min-h-(--control-h-md) cursor-default items-center gap-2 rounded-control px-2 text-sm text-fg outline-none " +
  "transition-colors duration-(--dur-fast) data-focused:bg-active data-pressed:bg-active data-disabled:opacity-45";

export const listPad = "p-1 outline-none";

export const sectionHeader = "px-2 pt-2 pb-1 text-2xs font-medium text-fg-subtle";
